import { useSessionQuery } from '../../api/api'

const useIsSubscribed = () => {
  const { data: user } = useSessionQuery()
  return user?.isSubscribed || false
}

export default useIsSubscribed
